import React from 'react'
import '../../style/component.css'
import { Avatar, Layout, Space } from 'antd';
import Logo from '../../assets/png/logo.png'
import ProfileMenu from './ProfileMenu';
import Notifications from '../../pages/notification/Notifications';
const { Header } = Layout;


function Headers() {
    return (
        <Header className='headers'>
            <div className='logo'>
                <img src={Logo} />
            </div>
            <Space>
                <Notifications />
                <div className="show_profile">
                    <ProfileMenu />
                </div>
            </Space>
        </Header>
    )
}

export default Headers